<div class="task-form-container">
  <!-- Error messages -->
  @if (errorMessages.length > 0) {
    <div class="alert alert-danger">
      @for (msg of errorMessages; track $index) {
        <div>{{ msg }}</div>
      }
    </div>
  }

  <!-- Success message -->
  @if (successMessage) {
    <div class="alert alert-success">{{ successMessage }}</div>
  }

  <!-- Library form component (renders its own action buttons from [availableActions]) -->
  <fb-bs-generic-formly-form
    [formDefinition]="formDefinition"
    [formData]="model"
    [viewMode]="isReadonly || shouldDisableInputs"
    [requestTypeLogicalId]="requestTypeLogicalId"
    [requestId]="requestId ? +requestId : undefined"
    [availableActions]="availableActions"
    (formSubmit)="onFormSubmit($event)">
  </fb-bs-generic-formly-form>

  <!-- No Actions Available (readonly) -->
  @if (!isLoading && (isReadonly || availableActions.length === 0)) {
    <div class="alert alert-info">
      {{ isReadonly ? ('task.viewOnly' | translate) : ('task.noActionsAvailable' | translate) }}
    </div>
  }

  <!-- Blocking loader, same .loading-state treatment as task-viewer.component.html.
       The library renders its own action buttons and exposes no submitting/disabled
       input, so laying this over the container is the only way to stop a second click
       firing a duplicate execute-action. -->
  @if (isLoading) {
    <div class="loading-state" role="status" aria-live="polite" [attr.aria-busy]="true">
      <div class="spinner"></div>
      <p>{{ 'common.submitting' | translate }}</p>
    </div>
  }
</div>
